export const alertStyles = {
  '&.MuiAlert-colorInfo': {
    borderLeft: 'none',
  },
};
